import * as z from 'zod'
import {HL7Status} from '@cypro/engine/database/schema'

export const Hl7FiltersSchema = z.object({
  status: z.array(HL7Status).optional(),
  createdAtFrom: z.number().optional(),
  createdAtTo: z.number().optional(),
})

export const Hl7SearchSchema = z.object({
  filters: Hl7FiltersSchema.optional(),
})
